import { FormikValues } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import { Card } from '@material-ui/core';
import { Assignment as AssignmentIcon } from '@material-ui/icons';
import { InlineForm, InlineFormik } from '@sierralabs/react-material-ui-formik';
import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';
import InlineHtml from '../../../common/inline/InlineHtml';
import { InlineFileValue } from '../../../common/inline/InlineFile';
import { FetchError } from '../../../common/api/api';
import { HazardControl } from '../Hazard.interface';
import { useUpdateHazardControl } from '../Hazard.hooks';
import { useTaskEntityFields } from '../../workflow/Workflow.hooks';
import { useUpdateTask } from '../../tasks/Task.hooks';

const HazardControlVerificationCard: React.FC<{
  hazardId: number;
  control: HazardControl;
  onChange?: (control: HazardControl) => void;
  onUpdate?: () => void;
}> = ({ hazardId, control, onChange, onUpdate }) => {
  const { controlVerification } = control;
  const [error, setError] = useState<FetchError | undefined>();
  const {
    updatedHazardControl,
    isUpdatingHazardControl,
    updateHazardControlError,
    updateHazardControl
  } = useUpdateHazardControl(hazardId, control.id);
  const {
    updatedTask,
    updateError: updateTaskError,
    updateTask
  } = useUpdateTask(control.task.id || 0);
  const formikRef = useRef<FormikValues>();
  const onChangeRef = useRef(onChange);
  useEffect(() => {
    if (updatedHazardControl) {
      onChangeRef.current?.(updatedHazardControl);
    }
  }, [updatedHazardControl]);
  const { isFieldDisabled } = useTaskEntityFields(control.task);
  useEffect(() => {
    if (updatedTask) {
      control.task = Object.assign(control.task || {}, updatedTask);
      onChange?.(control);
      onUpdate?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedTask]);
  useEffect(() => {
    setError(updateTaskError || updateHazardControlError);
  }, [updateTaskError, updateHazardControlError]);
  return (
    <Card>
      <CardTitle>
        <AssignmentIcon /> Control Verification
      </CardTitle>
      <CardContent padding='large'>
        <InlineFormik
          error={error}
          isSubmitting={isUpdatingHazardControl}
          innerRef={(formik: any) => (formikRef.current = formik)}
          initialValues={{
            controlVerification: controlVerification || ''
          }}
          onSubmit={(dto: Partial<HazardControl>) => {
            updateHazardControl(dto);
          }}
        >
          <InlineForm>
            <InlineHtml
              name='controlVerification'
              label='Control Verification'
              disabled={
                isUpdatingHazardControl ||
                isFieldDisabled('controlVerification')
              }
              attachments={control.task.attachments || []}
              onChangeAttachments={(attachments: InlineFileValue[]) => {
                updateTask({ attachments });
                if (control.task) {
                  control.task.attachments = attachments;
                }
                onChange?.(control);
              }}
            />
          </InlineForm>
        </InlineFormik>
      </CardContent>
    </Card>
  );
};

export default HazardControlVerificationCard;
